<template>
	<v-menu auto>
		<template v-slot:activator="{ on }">
			<v-btn class="menu-icon" color="ocean" icon @click="on.click">
				<v-icon>fas fa-plus</v-icon>
			</v-btn>
		</template>

		<v-list>
			<v-list-item @click="fnAddCommandStep">
				<v-list-item-icon>
					<v-icon color="ocean">fas fa-plug</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Execute a command</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item @click="fnAddEventStep">
				<v-list-item-icon>
					<v-icon color="ocean">fas fa-running</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Fire an event</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item @click="fnAddDelayStep">
				<v-list-item-icon>
					<v-icon color="ocean">far fa-clock</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>Add delay</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	props: {
		fnAddCommandStep: {
			type: Function,
			required: true,
		},
		fnAddEventStep: {
			type: Function,
			required: true,
		},
		fnAddDelayStep: {
			type: Function,
			required: true,
		},
	},
};
</script>
